import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';
import { LevelingAction } from '../../shared/types/leveling-action';
import { LpConstants } from '../../shared/types/lp-constants';
import { WindowService } from '../../shared/window.service';

const OFFSET_HEIGHT = 68;

@Component({
  selector: 'lp2-progress-test-page',
  template: `
    <div class="wrapper container">
      <div id="content">
        <iframe
          *ngIf="progressTestUrl"
          #iframe
          lp2UserwaySync
          height="100%"
          width="100%"
          [src]="progressTestUrl | safeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressTestPageComponent implements OnInit, OnDestroy {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  progressTestUrl: string;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private windowService: WindowService
  ) { }

  ngOnInit() {
    if (this.oeAppPersonService.levelingAction !== LevelingAction.ProgressTestBanner) {
      this.windowService.redirectToHref(LpConstants.STUDY_BUNDLE_URL);
      return;
    }
    window.addEventListener('message', this.handleEvents.bind(this), false);
    this.setProgressTestUrl();
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  private setProgressTestUrl() {
    const successUrl = window.location.origin + LpConstants.STUDY_BUNDLE_URL;
    this.progressTestUrl =
      this.oeApp.lp2LearnosityUiHost + '/progress-test' +
      '?lang=' + this.oeAppPersonService.preferredLang +
      '&levelNum=' + this.oeAppPersonService.levelNum +
      '&successUrl=' + successUrl;
  }

  private handleEvents({ data, origin }) {
    if (isIFrameSameOrigin(window.location.href, origin)) {
      return;
    }

    if (data.type === IFrameSizeEventType.HEIGHT) {
      this.iframe.nativeElement.height = data.height + OFFSET_HEIGHT;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress-test/progress-test-page/progress-test-page.component.ts